import { Button, Dialog, Input } from '@platform/design-system';
import { useEffect, useRef, useState } from 'react';
import { usePageContext } from '../../usePageContext.ts';

const MAX_NAME = 60;

export type NameViewDialogProps = {
  title: string;
  initialName: string;
  onClose: () => void;
  onSubmit: (name: string) => void;
};

export const NameViewDialog = ({ title, initialName, onClose, onSubmit }: NameViewDialogProps) => {
  const { t } = usePageContext();
  const [name, setName] = useState(initialName);
  const [touched, setTouched] = useState(false);
  const field = useRef<HTMLInputElement>(null);
  useEffect(() => {
    field.current?.focus();
  }, []);
  const trimmed = name.trim();
  const missing = trimmed === '';
  const submit = () => {
    setTouched(true);
    if (!missing) onSubmit(trimmed);
  };
  return (
    <Dialog
      open
      title={title}
      closeLabel={t('common.close')}
      onClose={onClose}
      footer={
        <>
          <Button variant="ghost" onClick={onClose}>
            {t('common.cancel')}
          </Button>
          <Button onClick={submit}>{t('common.save')}</Button>
        </>
      }
    >
      <form
        onSubmit={(event) => {
          event.preventDefault();
          submit();
        }}
      >
        <Input
          ref={field}
          label={t('dashboard.views.nameLabel')}
          required
          maxLength={MAX_NAME}
          value={name}
          errorText={touched && missing ? t('dashboard.views.nameRequired') : undefined}
          onBlur={() => {
            setTouched(true);
          }}
          onChange={(event) => {
            setName(event.target.value);
          }}
        />
      </form>
    </Dialog>
  );
};
